import { useMemo } from 'react';
import { useParams } from 'react-router';

import { useCoefficientsOptions } from '../store';

export const useCoefficientsConfig = () => {
  const { options } = useCoefficientsOptions();
  const { type, mode } = useParams();

  const selectedConfig = useMemo(
    () => options.coefficientsDropdown?.find((item) => item.path === mode || item.path === `${type}/${mode}`),
    [mode, type, options.coefficientsDropdown],
  );

  const configuration = useMemo(() => {
    if (!selectedConfig) return options.initialConfig;

    return {
      ...options.initialConfig,
      ...selectedConfig,
    };
  }, [options.initialConfig, selectedConfig]);

  return { configuration, selectedConfig };
};
